import { lazy } from "react";
import { Navigate } from "react-router-dom";

import FullLayout from '../layouts/FullLayout/FullLayout';

const BasicTable = lazy(() => import("../views/tables/BasicTable.js"));

// form elements
const ExAutoComplete = lazy(() =>  import("../views/FormElements/ExAutoComplete.js"));
const ExButton = lazy(() => import("../views/FormElements/ExButton.js"));
const ExCheckbox = lazy(() => import("../views/FormElements/ExCheckbox.js"));
const ExRadio = lazy(() => import("../views/FormElements/ExRadio.js"));
const ExSlider = lazy(() => import("../views/FormElements/ExSlider.js"));
const ExSwitch = lazy(() => import("../views/FormElements/ExSwitch.js"));
// form layouts
const FormLayouts = lazy(() => import("../views/FormLayouts/FormLayouts.js"));

const HomeTab       = lazy(() => import("../views/Tabs/HomeTab.js"));
const PeopleTab     = lazy(() => import("../views/Tabs/PeopleTab.js"));
const ArticlesTab   = lazy(() => import("../views/Tabs/ArticleTab.js"));
const TechnologyTab = lazy(() => import("../views/Tabs/TechnologyTab.js"));
const ConsultingTab = lazy(() => import("../views/Tabs/ConsultingTab.js"));

const Arts      = lazy(() => import("../views/articles/NineArts.js"));
const Professor = lazy(() => import("../views/articles/VisitingProfessor.js"));
const Code      = lazy(() => import("../views/articles/CleanCode.js"));
const Arch      = lazy(() => import("../views/articles/CleanArchitecture.js"));
const Interview = lazy(() => import("../views/articles/CSInterview.js"));
const Design    = lazy(() => import("../views/articles/TestableDesign.js"));
const Mon1      = lazy(() => import("../views/articles/TransformMonolith1.js"));
const Mon2      = lazy(() => import("../views/articles/TransformMonolith2.js"));

const Eco       = lazy(() => import("../views/technology/Skillset.js"));
const Plat      = lazy(() => import("../views/technology/Architecture.js"));
const React     = lazy(() => import("../views/technology/React.js"));
const Angular   = lazy(() => import("../views/technology/Angular.js"));
const Blazor    = lazy(() => import("../views/technology/Blazor.js"));
const Desk      = lazy(() => import("../views/technology/Wpf.js"));

const Omega     = lazy(() => import("../views/consulting/Omega.js"));
const Pm        = lazy(() => import("../views/consulting/PMDashboard.js"));
const Prof      = lazy(() => import("../views/consulting/DesignPattern.js"));
const Spina     = lazy(() => import("../views/consulting/Spina.js"));
const Muni      = lazy(() => import("../views/consulting/Munichain.js"));
const Donation  = lazy(() => import("../views/consulting/Donations.js"));

/*****Routes******/

const ThemeRoutes = [
  {
    path: "/",
    element: <FullLayout />,
    children: [

      { path: "/",                               element: <Navigate to="form-elements/home" /> },
      { path: "form-elements/home", exact: true, element: <HomeTab/> },
      { path: "/form-elements/people"  ,         element: <PeopleTab/> },

      { path: "/form-elements/articles",                element: <ArticlesTab/> },
      { path: "/form-elements/technology",              element: <TechnologyTab/> },
      { path: "/form-elements/consulting",              element: <ConsultingTab/> },
      
      { path: "/form-elements/articles/arts",           element: <Arts /> },          
      { path: "/form-elements/articles/professor",      element: <Professor/> },      
      { path: "/form-elements/articles/code",           element: <Code/> },           
      { path: "/form-elements/articles/architecture",   element: <Arch/> },           
      { path: "/form-elements/articles/interview",      element: <Interview/> },      
      { path: "/form-elements/articles/monolith1",      element: <Mon1/> },           
      { path: "/form-elements/articles/monolith2",      element: <Mon2/> },           
      { path: "/form-elements/articles/design",         element: <Design/> },         

      { path: "/form-elements/technology/eco",          element: <Eco/> },      
      { path: "/form-elements/technology/react",        element: <React/> },           
      { path: "/form-elements/technology/angular",      element: <Angular/> },           
      { path: "/form-elements/technology/blazor",       element: <Blazor/> },           
      { path: "/form-elements/technology/architecture", element: <Plat/> },
      { path: "/form-elements/technology/desktop",      element: <Desk/> },

      { path: "/form-elements/consulting/option",       element: <Omega/> },      
      { path: "/form-elements/consulting/pmdash",       element: <Pm/> },           
      { path: "/form-elements/consulting/design",       element: <Prof/> },           
      { path: "/form-elements/consulting/medical",      element: <Spina/> },         
      { path: "/form-elements/consulting/munichain",    element: <Muni/> },         
      { path: "/form-elements/consulting/donation",     element: <Donation/> },         

      { path: "tables/basic-table",          element: <BasicTable /> },
      { path: "/form-layouts/form-layouts",  element: <FormLayouts /> },
      { path: "/form-elements/autocomplete", element: <ExAutoComplete /> },
      { path: "/form-elements/checkbox",     element: <ExCheckbox /> },
      { path: "/form-elements/radio",        element: <ExRadio /> },
      { path: "/form-elements/slider",       element: <ExSlider /> },
      { path: "/form-elements/switch",       element: <ExSwitch /> },
    ],
  },
];

export default ThemeRoutes;
